import { filter } from "lodash";

/* eslint-disable  */
export default {
  init() {
    // JavaScript to be fired on the race trip page

    /* function setTrip(id) {
      $(".grid-filterable").addClass("hidden");
      $(id).removeClass("hidden");

      if ($(id).data("stages")) {
        let stages = $(id).data("stages").split(",").filter(Boolean);
        let liveStages = $(id).data("livestages").split(",");
        $(".stage-row").removeClass("active live first last");
        for (let i = 0; i < stages.length; i++) {
          if (stages[i] !== "") {
            $("#stage-" + stages[i]).addClass("active");
            if (i === 0) {
              $("#stage-" + stages[i]).addClass("first");
            }
            if (i === stages.length - 1) {
              $("#stage-" + stages[i]).addClass("last");
            }
            if (liveStages.includes(stages[i])) {
              $("#stage-" + stages[i]).addClass("live");
            }
          }
        }
      }
    }*/

    //setTrip($(".btn-trip-select.active").data("target"));

    // setting up table expand UX
    $(window).load(function () {
      toggleOut();
    });

    window.onresize = updateTableToggle;

    function toggleIn() {
      $(".detail-col").removeClass("active");
      $(".btn-show-details").removeClass('active');
      $(".btn-show-details span").text('CLICK TO SEE STAGE DETAIL');
      $(".stage-col").addClass('detail-closed');
      const $date_col = $(".date-col").outerWidth();
      const $stage_col = $(".stage-col").outerWidth();
      const $btn_width = $(".btn-show-details").outerWidth();
      const $total = $stage_col + $date_col - $btn_width;

      $(".btn-show-details").css({
        left:$total
      });
    }

    function toggleOut() {
      $(".detail-col").addClass("active");
      $(".btn-show-details").addClass('active');
      $(".btn-show-details span").text('CLICK TO HIDE STAGE DETAIL');
      $(".stage-col").removeClass('detail-closed');
      const $date_col = $(".date-col").outerWidth();
      const $stage_col = $(".stage-col").outerWidth();
      const $detail_col = $(".detail-col").outerWidth();
      const $btn_width = $(".btn-show-details").outerWidth();
      const $total = $detail_col + $date_col + $stage_col - $btn_width + 1;

      $(".btn-show-details").css({
        left:$total
      });
    }

    function updateTableToggle() {
      toggleIn();
      const tableWidth = $('.container').innerWidth();
      console.log(tableWidth);
      $('.trip-stages-table').css({'maxWidth': tableWidth + 'px'});
    }

    $(".btn-show-details").on("click", function () {
      if ($(".detail-col").hasClass("active")) {
        toggleIn();
      } else {
        toggleOut();
      }
    });

    $(".btn-trip-select").on("click", function () {
      $(".btn-trip-select").removeClass("active");
      $(this).addClass("active");
      $(".tdf-trips--detail").addClass("hidden");
      let id = $(this).data("target");
      $(id).removeClass("hidden").addClass("active");
    });

    $(".stage-card--actions .btn.btn-action").on("click", function () {
      let tar = $(this).attr("data-target");
      let card = $(this).parent().parent();
      card.find(".btn.btn-action.active").removeClass("active");
      card.find(".stage-card__view.active").removeClass("active");
      card.find(`.stage-card__${tar}`).addClass("active");
      $(this).addClass("active");
    });

    $(".tdf-schedule--view__select").on("change", function () {
      $(this.value).addClass("active");
      let start = parseInt($(this.value).data("startday"));
      let duration = parseInt($(this.value).data("duration"));
      let liveStages = $(this.value).data("stages");
      var table = document.getElementById("tdf-schedule--table");
      for (var i = 0, row; (row = table.rows[i]); i++) {
        let rowDay = $(row).data("day");
        if (rowDay >= start && rowDay < start + duration) {
          $(row).addClass("active");
          console.log(liveStages);
          if (
            filter(liveStages, function (o) {
              return parseInt(o.stage) === parseInt($(row).data("id"));
            }).length
          ) {
            $(row).children("td").last().html("YES");
          } else {
            $(row).children("td").last().html("");
          }
        } else {
          $(row).removeClass("active");
          $(row).children("td").last().html("");
        }
      }
    });

    $(".stage-row").on("click", function () {
      if ($(this).hasClass("active")) {
        let t = $(".trip-calendar--grid--card__wrap").not(".hidden");
        let a = t.find("a").first();
        window.location.href = a[0].href;
      }
    });

    $(".climbs-next").on("click", function () {
      let current = parseInt($(this).parent().attr("data-current"));
      let total = parseInt($(this).parent().attr("data-total"));
      $(this)
        .parent()
        .find(".stage-card__climbs--item.active")
        .removeClass("active");
      let next = current === total ? 1 : current + 1;
      $(this).parent().attr("data-current", next);
      $(this)
        .parent()
        .find(`.stage-card__climbs--item--${next}`)
        .addClass("active");
    });

    $(".climbs-prev").on("click", function () {
      let current = parseInt($(this).parent().attr("data-current"));
      let total = parseInt($(this).parent().attr("data-total"));
      $(this)
        .parent()
        .find(".stage-card__climbs--item.active")
        .removeClass("active");
      let next = current === 1 ? total : current - 1;
      $(this).parent().attr("data-current", next);
      $(this)
        .parent()
        .find(`.stage-card__climbs--item--${next}`)
        .addClass("active");
    });

    cardsShowHide();

    $(".expand-collapse--trigger").on("click", () => {
      cardsShowHide();
    });

    function cardsShowHide() {
      if ($(".expand-collapse--trigger").hasClass("open")) {
        $(".stage-card").addClass("active");
      } else {
        let i = 0;
        $(".stage-card").each(function () {
          if ($(window).width() >= 992 && i < 3) {
            $(this).addClass("active");
          } else if (i === 0) {
            $(this).addClass("active");
          } else {
            $(this).removeClass("active");
          }
          i++;
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/tourDeFrance.js